import { request } from '@/utils/request'
// 接口路径
const API ={
  getCaptcha: '/public/getCaptcha',
  login: '/public/login',
  loginOut: '/public/logout',
}
// 获取图形验证码
export function getCaptcha() {
  return request.get(API.getCaptcha)
}

// 登录
export function login(params) {
  return request.post(API.login, params, {
    headers: { 'Content-Type': 'application/json' }
  })
}
// 退出登录
export function loginOut() {
  return request.post(API.loginOut)
}

export default {
  getCaptcha,
  login,
  loginOut
}


